import { render, staticRenderFns } from "./LogoutComplete.vue?vue&type=template&id=2705da09&scoped=true"
import script from "./LogoutComplete.vue?vue&type=script&lang=js"
export * from "./LogoutComplete.vue?vue&type=script&lang=js"
import style0 from "./LogoutComplete.vue?vue&type=style&index=0&id=2705da09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2705da09",
  null
  
)

export default component.exports